import React, { useState, useEffect } from "react";
import { useLoader, useFrame } from "@react-three/fiber";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { useSpring, animated, config } from "@react-spring/three";
import { history } from "./History";
import { Html, Sphere } from "@react-three/drei";

function SphereHome({ episode, hovered, setHovered, episodeName, mobile }) {
  function MyRotatingSphere() {
    const [active, setActive] = useState(false);
    const [hidden, set] = useState();

    useEffect(() => {
      document.body.style.cursor = active || hovered ? "pointer" : "grab";
    }, [active]);

    const isHovered = () => {
      setActive(true);
      // setHovered(true);
    };
    const notHovered = () => {
      setActive(false);
      // setHovered(false);
    };

    const { scale } = useSpring({
      scale: active ? 1.5 : 1,
      config: config.slow,
    });
    const myMesh = React.useRef();

    const redirect = () => {
      history.push("/episode10");
    };

    return (
      <animated.mesh
        position={[10, 2, 5]}
        scale={scale}
        onPointerOver={isHovered}
        onPointerOut={notHovered}
        visible
        userData={{ test: "hello" }}
        castShadow
        onClick={redirect}
      >
        <sphereGeometry attach="geometry" args={[0.7, 26, 26]} />
        <meshMatcapMaterial attach="material" color="red" />
        {(active || mobile) && (
          <Html
            wrapperClass="overlay-wrapper"
            occlude
            onOcclude={set}
            style={{
              transition: "all 0.5s",
              opacity: hidden ? 0 : 1,
            }}
            className="overlay"
            center={true}
            position={[0, 0.8, 0]}
            distanceFactor={10}
          >
            <div className="content">EPISODE 10 : Ce son en cache un autre</div>
          </Html>
        )}
      </animated.mesh>
    );
  }

  return <MyRotatingSphere />;
}

export default SphereHome;
